// extracted by mini-css-extract-plugin
export var numpadContainer = "_ni-1";
export var phoneButton = "_ni-0";